import { getAxiosClient } from "../../axios-client";
import { DeletePackageRequestBody, DeletePackageResponse } from "./types";

const axiosClient = getAxiosClient();
export const deletePackage = async (body: DeletePackageRequestBody) => {
  return await axiosClient.ax.delete<DeletePackageResponse>(
    "/Packages/Delete",
    { data: body }
  );
};
